import axios from 'axios';

import urls from '../../utils/urls';
import {tokenHeader} from '../../utils/headers';

export const GROUPS_FETCHED = 'GROUPS_FETCHED';


export function fetchGroups() {
    return (dispatch) => {
        const groups_url = `${urls.API_ROOT}/api/v1/role/`;
        axios
            .get(groups_url, tokenHeader())
            .then((response) => dispatch(groupsFetched(response.data)))
            .catch(console.log);
    }
}

export function groupsFetched(data){
    return {
        type: GROUPS_FETCHED,
        payload:data
    };
}






// WEBPACK FOOTER //
// ./src/actions/groups_actions/index.js